import React, { useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { CategoryBtns, WaterfallTemplate } from '../index'
import ClassicListTemplate from './ClassicListTemplate'
import { cloneDeep, keyBy } from '@dt/fe-utils/dist/lodash'
import { mallMobx } from 'mobx/mall'
import { decorationMobx } from '@mobxStore'
import { classNames } from '@dt/fe-utils'
import './index.scss'

const ProductTemplate = () => {
  const [productsTop, setProductsTop] = useState([])
  const [productsOther, setProductsOther] = useState([])
  const [activeCategoryNo, setActiveCategoryNo] = useState('')
  const isClassicBig = decorationMobx.mallGlobalDecorates?.displayMode === 'classicBig'
  const isClassicList = decorationMobx.mallGlobalDecorates?.displayMode === 'classicList'
  const hasSideCategory = isClassicBig || isClassicList
  const categories = mallMobx.categories
  const allProducts = mallMobx.products
  const classicBigProducts = useMemo(() => {
    return categories.reduce((result, category) => {
      const categoryProducts = [...category.products].sort((a, b) => {
        const aSort = a.sortInCategory?.[category.no] ?? a.id
        const bSort = b.sortInCategory?.[category.no] ?? b.id
        return bSort - aSort
      })
      return result.concat(categoryProducts.map(product => ({
        ...product,
        categoryNo: category.no,
        layoutKey: `${product.no}-${category.no}`,
        layoutType: 'waterfall'
      })))
    }, [])
  }, [categories])
  const products = isClassicBig ? classicBigProducts : allProducts

  useEffect(() => {
    if (hasSideCategory) {
      mallMobx.selectCategory('')
      setActiveCategoryNo(categories[0]?.no || '')
    }
  }, [hasSideCategory, categories.length])

  useEffect(() => {
    if (isClassicBig) {
      setProductsTop([])
      setProductsOther(products)
      return
    }
    const topList = mallMobx.brandProductTop?.productList || []
    const map = keyBy(cloneDeep(topList), item => item.productId) || {}
    let top = []
    let other = []
    products.forEach((item) => {
      if (map[item.id]) {
        top.push(item)
      } else {
        other.push(item)
      }
    })
    setProductsTop([...top])
    setProductsOther([...other])
  }, [products, isClassicBig])
  return (
    <div className={classNames('mall-product-template', { 'classic-big': isClassicBig, 'classic-list': isClassicList })}>
      {
        isClassicBig
          ? (
            <div className='mall-classic-big-layout'>
              {!mallMobx.isLoading && !!categories.length && (
                <CategoryBtns
                  mode='vertical'
                  selectedNo={activeCategoryNo}
                  onSelectCategory={setActiveCategoryNo}
                />
              )}
              <WaterfallTemplate
                products={productsOther}
                productsTop={productsTop}
                mode='classicBig'
                onActiveCategoryChange={setActiveCategoryNo}
              />
            </div>
          )
          : isClassicList
            ? (
              <div className='mall-classic-list-layout'>
                {!mallMobx.isLoading && !!categories.length && (
                  <CategoryBtns
                    mode='vertical'
                    variant='classicList'
                    selectedNo={activeCategoryNo}
                    onSelectCategory={setActiveCategoryNo}
                  />
                )}
                <ClassicListTemplate
                  categories={categories}
                  onActiveCategoryChange={setActiveCategoryNo}
                />
              </div>
            )
            : <WaterfallTemplate products={productsOther} productsTop={productsTop} mode='classic' />
      }
      {/* 底部分类btns */}
      {/* <CategoryBtns /> */}
    </div>
  )
}

export default observer(ProductTemplate)
